import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';

const ProtectedRouteLogin = ({ children }) => {
  const { user } = UserAuth();

  if (user) {
    return <Navigate to='/dashboard' />;
  }
  return children;
};

const ProtectedRoute = ({ children }) => {
  const { user } = UserAuth();

  if (!user) {
    return <Navigate to='/login' />;
  }
  return children;
};

export { ProtectedRoute, ProtectedRouteLogin };